import Seo from "@/lib/Seo";
import DiagnosticForm from "@/components/DiagnosticForm";
import SiaqLine from "@/components/SiaqLine";

export default function DiscoverContext() {
  return (
    <>
      <Seo path="/discover-context" title="اكتشف سياق منظمتك" description="ابدأ تشخيص منظمتك: املأ النموذج ليتواصل معك فريق سياق." />
      <header className="relative bg-navy text-white pt-32 pb-16 overflow-hidden" style={{ backgroundColor: "var(--navy)" }}>
        <SiaqLine variant="flow" className="absolute bottom-0 inset-x-0 h-16 w-full opacity-70" />
        <div className="mx-auto max-w-[900px] px-6 sm:px-10 relative">
          <span className="eyebrow mb-5">لسياقك نبتكر</span>
          <h1 className="font-display leading-tight" style={{ fontSize: "clamp(1.7rem, 3.3vw, 2.8rem)" }}>صف احتياجك</h1>
          <p className="mt-5 text-white/75 text-lg max-w-2xl leading-relaxed">
            أخبرنا عن منظمتك والتحدي الذي تواجهه، وسنعود إليك بخطوة أولى نحو حلٍّ مصمّم على سياقك.
          </p>
        </div>
      </header>
      <div className="bg-paper py-16">
        <div className="mx-auto max-w-[900px] px-6 sm:px-10">
          <DiagnosticForm />
        </div>
      </div>
    </>
  );
}
